export const blockIconsImageWbSunny = (
	<span className='material-symbols-outlined'>wb_sunny</span>
);
